import { TFormFaCodeForm } from './forms.2FACode.d'
import { TFormFaNumberForm } from './forms.2FANumber.d'
import { HEALTH_SYSTEM_STATUSES } from '../../constants'
import { TAddEditHospitalForm } from './forms.addEditHospital.d'
import { TFormContactUsForm } from './forms.contactUs.d'
import { TPurchaseOrdersForm } from './forms.editPurchaseOrder.d'
import { TFormForgotPasswordForm } from './forms.forgotPassword.d'
import { TFormSignInForm } from './forms.signIn.d'
import { TFormSignUpForm } from './forms.signUp.d'
import { TFormContactUsLandingForm } from './forms.contactUsLanding.d'

export const faCodeInitialValues: TFormFaCodeForm = {
  sms_code: '',
  token: ''
}

export const faNumberInitialValues: TFormFaNumberForm = {
  phone_number: ''
}

export const healthSystemsInitialValues = {
  name: '',
  email: '',
  state: '',
  phone_number: '',
  zip_code: '',
  city: '',
  street: '',
  status: HEALTH_SYSTEM_STATUSES.ACTIVE
}

export const hospitalInitialValues: TAddEditHospitalForm = {
  name: '',
  website: '',
  state: '',
  phone_number: '',
  zip_code: '',
  city: '',
  street: '',
  departments: []
}

export const contactUsInitialValues: TFormContactUsForm = {
  email: '',
  message: ''
}

export const contactUsLandingInitialValues: TFormContactUsLandingForm = {
  email: '',
  first_name: '',
  phone_number: '',
  organization_name: '',
  text: '',
  last_name: ''
}

export const purchaseOrderInitialValues: TPurchaseOrdersForm = {
  quantity: '',
  price: '',
  total_cost: '',
  order_date: '',
  is_disabled: false,
  uuid: '',
  contract_number: ''
}

export const forgotPasswordInitialValues: TFormForgotPasswordForm = {
  email: ''
}

export const signInInitialValues: TFormSignInForm = {
  email: '',
  password: ''
}

export const signUpInitialValues: TFormSignUpForm = {
  password: '',
  repeatPassword: '',
  agreement: false
}
